var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "switch" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.checkedLocal,
          expression: "checkedLocal"
        }
      ],
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.checkedLocal)
          ? _vm._i(_vm.checkedLocal, null) > -1
          : _vm.checkedLocal
      },
      on: {
        change: [
          function($event) {
            var $$a = _vm.checkedLocal,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.checkedLocal = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.checkedLocal = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checkedLocal = $$c
            }
          },
          _vm.toggle
        ]
      }
    }),
    _c("span", { staticClass: "slider round" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }